import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const ARTCAST_ARTWORKS_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/artworks',
        iconClass: 'fas fa-pencil-ruler',
        name: 'Artwork',
        layout: eLayoutType.application,
        requiredPolicy: 'Artcast.Artworks',
        order: 3
      },
    ]);
  };
}
